import * as $ from 'jquery'

export function onAttendanceChange(registrationSerial:string, attendanceName:string) {
	var dateDiv    = $(`#ad_${registrationSerial}`);
	var yesChecked = $(`#${attendanceName}_yes:checked`).length;
	if (yesChecked) {
		dateDiv.show();
	} else {
		dateDiv.hide();
	}
}


// WEBPACK FOOTER //
// ./src/events2/event-attendance.ts